import './styles/index.scss';
import Mustache from 'mustache';
import $ from 'jquery';
import { gsap, TweenLite, Power1 } from 'gsap/all';
import countries from './config/countries.json';
import rCountries from './config/related-countries.json';
import continents from './config/continents.json';
import pins from './config/pins.json';
import mainTemplate from './templates/main.html';
import childMapTemplate from './templates/child-map.html';
import childMapModalTemplate from './templates/child-map-modal.html';
import globalMapTemplate from './templates/map-global.html';
import americaMapTemplate from './templates/map-america.html';
import africaMapTemplate from './templates/map-africa.html';
import asiaMapTemplate from './templates/map-asia.html';
import europeMapTemplate from './templates/map-europe.html';

gsap.registerPlugin(TweenLite);

const scriptEl = document.currentScript;

export default class App{
    /**
     * Initialize the object instance
     * @constructor
     */
    constructor(){
        this.$container = $('#wtsim-container');

        if(!this.$container.length)
            return;

        this.defaultColor = window.WTSIM_DEFAULT_COLOR || '#dcdfe1';
        this.accentColor = window.WTSIM_ACCENT_COLOR || '#cc1f36';
        this.hasCountryPins = this.$container.data('country-pins');

        this.render();
        this.addPinListeners();


    }

    addGlobalCountryPin(group, code) {
        // Compute the bounding box of the group to find its center
        var bbox = group.getBBox();
        var centerX = bbox.x + bbox.width / 2;
        var centerY = bbox.y + bbox.height / 2;

        // Create a foreignObject element in the SVG namespace
        var foreign = document.createElementNS("http://www.w3.org/2000/svg", "foreignObject");
        // Optionally define a width and height for the foreignObject;
        // if you want the CSS element to be fully interactable or visible, you might need to give it nonzero dimensions.
        // For example, if you expect the CSS element to be 20x20px, you can set these dimensions.
        foreign.setAttribute("width", "12");
        foreign.setAttribute("height", "12");
        // Position the foreignObject so that its center matches the calculated center.
        // Adjust x and y by subtracting half of the foreignObject's width/height (here 10 each)
        foreign.setAttribute("x", centerX - 10);
        foreign.setAttribute("y", centerY - 10);
        foreign.setAttribute('class', 'map-pin--' + code );
        foreign.setAttribute('title', 'map-pin--' + code );

        // Create a container div for the CSS element.
        var $div = $('<div class="map-pin"></div>');
        foreign.appendChild($div[0]);

        // Append the foreignObject into the group.
        $('.wtsim-map svg').append(foreign);
    }

    /**
     * Renders the initial display
     */
    render(){
        // set modal container
        $('body').append($('<div class="wtsim-map-modals"></div>'));

        // Child Maps and Child Map Modals
        let childMaps = '', childMapModals = '';
        continents.map(continent => {
            var map;

            if('americas' === continent.id)
                map = americaMapTemplate;
            else if('africa' == continent.id)
                map = africaMapTemplate;
            else if('asia' == continent.id)
                map = asiaMapTemplate;
            else if('europe' == continent.id)
                map = europeMapTemplate;

            childMaps += Mustache.render(childMapTemplate, {
                ID: continent.id,
                MAP: map,
            });

            childMapModals += Mustache.render(childMapModalTemplate, {
                ID: continent.id,
                MAP: map,
                TITLE: continent.name,
                DESCRIPTION: window.WTSIM_INNER_DESCRIPTION || 'To learn more about jurisdiction-specific developments, click on the yellow pin and choose the relevant WTS Global publication of choice.',
                MAP_PINS: this.generatePins(continent.countries)
            });
        });

        this.$container.append(Mustache.render(mainTemplate, {
            TITLE: window.WTSIM_MAIN_TITLE || '[insert title]',
            DESCRIPTION: window.WTSIM_MAIN_DESCRIPTION || '[insert your description here]',
            GLOBAL_MAP: globalMapTemplate,
            CHILD_MAPS: childMaps
        })).addClass('wtsim-loaded');

        $('.wtsim-map-modals').html(childMapModals);

        this.eventHandlers();

        this.fixSVGonIE();

        this.fetchPins(window.interactiveMap2_Countries || this.$container.data('countries'));
        
        $('body').addClass('wtsim-initialized');
    }

    /**
     * Attaches event handlers to the specified element
     */
    eventHandlers(){
        // Paths on click
        var pathTriggers = [
            {
                paths: ['Europe'],
                childMap: '#child-map-europe',
                mapModal: '#map-modal-europe'
            },
            {
                paths: ['South America', 'North America'],
                childMap: '#child-map-americas',
                mapModal: '#map-modal-americas'
            },
            {
                paths: ['Africa'],
                childMap: '#child-map-africa',
                mapModal: '#map-modal-africa'
            },
            {
                paths: ['Asia', 'Australia & Oceania'],
                childMap: '#child-map-asia',
                mapModal: '#map-modal-asia'
            }
        ];
        pathTriggers.map(trigger => {
            trigger.paths.map(path => {
                var $childMap = $(trigger.childMap),
                    $mapModal = $(trigger.mapModal);
                
                this.$container.on('click', '.wtsim-global-map .wtsim-map svg [data-name="'+path+'"] path', () => {
                    this.childMapsTransition({
                        from: $childMap.get(0),
                        to: $mapModal.get(0),
                        before: () => {},
                        after: () => {
                            $('body').addClass('wtsim-child-map-open');
                            setTimeout(() => {$mapModal.addClass('wtsim-ready');}, 300);
                        }
                    });

                    // this.removeButtons();
                });
                
                $mapModal.on('click', '.wtsim-map-modal-close', () => {
                    this.childMapsTransition({
                        from: $mapModal.get(0),
                        to: $childMap.get(0),
                        before: () => {},
                        after: () => {
                            $('body').removeClass('wtsim-child-map-open');
                            $mapModal.removeClass('wtsim-ready');
                        }
                    });

                    // this.removeButtons();
                    this.hidePubsBox();
                });
            });
        });


        // Name tag on mouse hover
        $('body').find('.wtsim-map').each((key, map) => {
            $('svg [data-name=Countries] path', map).on('mousemove', this.showNameTag);
            $('svg [data-name=Countries] path', map).on('mouseout', this.hideNameTag);
        });

        $('body').find('.wtsim-map').each((key, map) => {
            $('svg [data-name=Countries] path', map).on('mousemove', this.showNameTag);
            $('svg [data-name=Countries] path', map).on('mouseout', this.hideNameTag);
        });

        // Click on pins
        $('.wtsim-pin').on('click', this.clickPins.bind(this));

        // Click on different areas of countries
        $('.wtsim-map-modals').on('click', 'svg [data-name=Countries] path', this.clickMapArea.bind(this));

        // Click on different areas of map
        $('.wtsim-map-modals').on('click', (e) => {
            if(!$(e.target).hasClass('wtsim-pin') && e.target.nodeName.toLowerCase() != 'path' && !$(e.target).hasClass('wtsim-button')){
                // this.removeButtons();
                // this.hideSidebar();
                // this.hidePubsBox();
            }
        });

        // Click sidebar close button
        $('body').on('click', '.wtsim-sidebar-close', () => {
            this.hideSidebar();
        });

        // click pubs close button
        $('body').on('click', '.wtsim-pubs .wtsim-pubs-close', () => {
            this.hidePubsBox();
        });
    }

    /**
     * Animates the map when zooming in/out
     * @param {Object} args
     */
    childMapsTransition(args){
        var fromMap     = args.from,
            toMap       = args.to,
            clone       = fromMap.cloneNode(true),
            before      = args.before,
            after       = args.after;

        var from    = this.calculatePosition(fromMap),
            to      = this.calculatePosition(toMap);

        if(typeof before === 'function')
            before();
        
        TweenLite.set([fromMap, toMap], { visibility: 'hidden', scrollTop: 0 });
        TweenLite.set(clone, { position: 'absolute', margin: 0, opacity: 1, visibility: 'visible', backgroundColor: '#fff' });
            
        document.body.appendChild(clone);
        $('body').addClass('wtsim-transitioning');
            
        var style = {
            x: to.left - from.left,
            y: to.top - from.top,
            width: to.width,
            height: to.height,
            autoRound: false,
            ease: Power1.easeOut,
            onComplete: function(){
                TweenLite.set(toMap, { visibility: "visible" });

                document.body.removeChild(clone);
                $('body').removeClass('wtsim-transitioning');

                if(typeof after === 'function')
                    after();
            }
        };
        
        TweenLite.set(clone, from);  
        TweenLite.to(clone, 0.8, style);
    }

    /**
     * Calculate the position of child map
     * @param {Element} element
     */
    calculatePosition(element){
        var root    = document.documentElement,
            body    = document.body;
            
        var rect = element.getBoundingClientRect();
        
        var scrollTop  = window.pageYOffset || root.scrollTop  || body.scrollTop  || 0;
        var scrollLeft = window.pageXOffset || root.scrollLeft || body.scrollLeft || 0;
        
        var clientTop  = root.clientTop  || body.clientTop  || 0;
        var clientLeft = root.clientLeft || body.clientLeft || 0;
        
        return {
            top: Math.round(rect.top + scrollTop - clientTop),
            left: Math.round(rect.left + scrollLeft - clientLeft),
            height: rect.height,
            width: rect.width,
        };
    }

    /**
     * Display the map label name
     * @param {Event} event
     */
    showNameTag(event){
        var $map = $(this).closest('.wtsim-map'),
            $tag = $map.find('.wtsim-name-tag'),
            name = $(this).data('name') || $(this).parent().data('name'),
            offset = $map.get(0).getBoundingClientRect();

        window.WTSIM_CURRENT_HOVER = name;

        $tag.text(name).css({
            display: 'block',
            left: Math.abs(offset.left - event.clientX - 10) + 'px',
            top: Math.abs(offset.top - event.clientY - 10) + 'px'
        });

        $(`[data-name="${name}"]`).addClass('is-hovered');

        if(rCountries[name]){
            $.each(rCountries[name], (i, e) => {
                $(`[data-name="${e}"]`).addClass('is-hovered');
            });
        }
    }

    /**
     * Hide the map label name
     */
    hideNameTag(){
        let name = $(this).data('name') || $(this).parent().data('name');
        
        $(this).closest('.wtsim-map').find('.wtsim-name-tag').text('').css('display', 'none');

        $(`[data-name="${name}"]`).removeClass('is-hovered');

        if(rCountries[name]){
            $.each(rCountries[name], (i, e) => {
                $(`[data-name="${e}"]`).removeClass('is-hovered');
            });
        }
    }

    /**
     * @param {Event} event
     */
    clickPins(event){
        if($(event.target).data('items')){
            event.preventDefault();
            this.showPubsBox(event);
        }
    }

    /**
     * @param {Event} event
     */
    clickMapArea(event){
        let name = $(event.target).data('name') || $(event.target).parent().data('name');
        let code = Object.keys(countries).find(key => countries[key].toLowerCase() === name.toLowerCase());

        if(code){
            let $pin = $(`#pin-${code}`);

            if($pin.length)
                $pin[0].click();
        }
    }

    /**
     * Shows the publication box
     * @param {Event} event
     */
    showPubsBox(event){
        const el = event.target;

        if(!$(el).length)
            return;

        const items = $(el).data('items');

        if(!items)
            return;

        const code = $(el).data('code');

        let count = 1;
        const list = items.filter((e, i) => i<999).map(item => {
            const name = item.name || `Publication ${count++}`;
            const type = item.type;
            const href = this.identifyUrlByType(type, item.url);

            return `<li><a href="${href}" target="_blank">${name}</a></li>`;
        }).join('');

        const $modal = $('body.wtsim-child-map-open').find('.wtsim-map-modal.wtsim-ready'),
                $box = $modal.find('.wtsim-pubs');

        $box.find('.wtsim-pubs-head h3').text(countries[code]);
        $box.find('.wtsim-pubs-body').html('<ul class="wtsim-pubs-nav">'+list+'</ul>');

        const top = $(`#pin-${code}`).css('top');

        $box.css('top', top).addClass('wtsim-active');
    }

    /**
     * Hides the any visible publication box
     */
    hidePubsBox(){
        $('.wtsim-map-modal .wtsim-pubs').removeClass('wtsim-active');

        setTimeout(() => {
            $('.wtsim-map-modal.wtsim-ready .wtsim-pubs .wtsim-pubs-head h3').text('');
            $('.wtsim-map-modal.wtsim-ready .wtsim-pubs .wtsim-pubs-body').html('');
        }, 400);
    }

    /**
     * Identify url by type
     * @param {String} type
     * @param {String} url
     */
    identifyUrlByType(type, url){
        let href;
        
        switch(type){
            case('pdf'):
                href = `${this.getPDFViewerUrl()}?file=${url}`;
                break;
            default:
                href = url;
        }

        return href;
    }

    /**
     * Creates all pins
     * @param {Array} items
     */
    generatePins(items){
        if(!Array.isArray(items))
            return;

        var element = '<div class="wtsim-map-pins">';

        items.map(code => {
            if($.inArray(code, Object.keys(pins)) !== -1){
                element += `<a class="wtsim-pin" id="pin-${code}" data-code="${code}" data-name="${countries[code]}" style="left:${pins[code][0]}%;top:${pins[code][1]}%;" target="_blank"><span>${countries[code]}</span></a>`;
            }
        });

        element += '</div>';

        return element;
    }

    /**
     * Fix SVG on Internet explorer
     */
    fixSVGonIE(){
        if(window.document.documentMode){
            var svg = document.querySelectorAll('svg[data-ie-ratio]');

            for(var i=0;i<svg.length;i++){
                var ratio = JSON.parse(svg[i].getAttribute('data-ie-ratio'));

                svg[i].setAttribute('preserveAspectRatio', 'xMidYMin slice');
                svg[i].style.width = '100%';
                svg[i].style.overflow = 'visible';
                svg[i].style.height = '1px';
                svg[i].style.paddingBottom = (ratio[1]/ratio[0]*100)+'%';
            }
        }
    }

    /**
     * Get the pins
     * @param {Array} input
     */
    fetchPins(input){
        this.clearPins();

        const data = input || {};

        if(!Object.values(data).length){
            console.log('Data is empty.');
            return;
        }

        this.fillCountries();
        data.availableCountries.map(code => {
            this.fillCountry(code.toUpperCase());

            $(`#pin-${code.toUpperCase()}`).css('display', 'block');

            const items = data.countryData[code].navigationItems;
            $(`#pin-${code.toUpperCase()}`).attr('data-items', JSON.stringify(items));
        });
    }

    /**
     * Hide the pins
     */
    clearPins(){
        $('.wtsim-map .wtsim-pin').css('display', 'none');
        $('.wtsim-map .wtsim-pin').removeAttr('href');
        $('.wtsim-map .wtsim-pin').removeAttr('data-items');
    }

    /**
     * Add color to countries
     */
    fillCountries(){
        $(`.wtsim-map svg [fill="#dcdfe1"]`).attr('fill', this.defaultColor);
        $(`.wtsim-map svg [fill="${this.accentColor}"]`).attr('fill', this.defaultColor);
    }

    /**
     * Add color to a country
     * @param {String} code
     * @param {String} color
     */
    fillCountry(code, color=null){
        color = color || this.accentColor;
        if (this.hasCountryPins) {
            if (code == 'US') {
                var $group = $('[data-name="USA"]');
                this.addGlobalCountryPin($group[1], code);
            }
            else {
                var $group = $('[data-name="' + countries[code] + '"]');
                if ($group && $group[0]) {
                    this.addGlobalCountryPin($group[0], code);
                }
            }
        }

        $(`.wtsim-map svg [data-name="${countries[code]}"]`).attr('fill', color);
        $(`.wtsim-map svg [data-name="${countries[code]}"] path`).attr('fill', color);

        if(rCountries[countries[code]]){
            rCountries[countries[code]].map(c => {
                $(`.wtsim-map svg [data-name="${c}"]`).attr('fill', color);
                $(`.wtsim-map svg [data-name="${c}"] path`).attr('fill', color);
            });
        }
    }

    /**
     * Gets PDF Vierwer url
     * @return {String}
     */
    getPDFViewerUrl(){
        return this.getCurrentPath() + '/public/viewer/web/viewer.html';
    }

    /**
     * Gets current path
     * @return {String}
     */
    getCurrentPath(){
        var fullUrl = scriptEl.src;
        return fullUrl.substring(0, fullUrl.lastIndexOf('/'));
    }

    addPinListeners(){
        $('.pin--americas').on('click', function() {
            $('.wtsim-global-map .wtsim-map svg [data-name="Argentina"] path').trigger('click');
        });
        $('.pin--europe').on('click', function() {
            $('.wtsim-global-map .wtsim-map svg [data-name="Italy"] path').trigger('click');
        });
        $('.pin--africa').on('click', function() {
            $('.wtsim-global-map [data-name="Tanzania"] path').trigger('click');
        });
        $('.pin--asia').on('click', function() {
            $('.wtsim-global-map .wtsim-map svg [data-name="China"] path').trigger('click');
        });
    }
}